function updateQueryParamInUrl(key, value) {
  const url = new URL(window.location.href);
  const params = new URLSearchParams(url.search);

  // Special case: always replace the "query" parameter
  if (key === 'query') {
    params.set('query', value);
  }

  // Special case: always replace the "page" parameter
  if (key === 'page') {
    params.set('page', value);
  }

  // Special case: always replace the "sortBy" parameter
  if (key === 'sortBy') {
    params.set('sortBy', value);
  }

  // Handle refinementList group like: refinementList[articleTags.name]
  else if (key.startsWith('refinementList[')) {
    const match = key.match(/^refinementList\[(.*?)\]$/);

    if (match) {
      const group = match[1];

      // Parse existing refinementList or start fresh
      let refinementList = {};
      try {
        refinementList = JSON.parse(params.get('refinementList') || '{}');
      } catch (e) {
        console.warn('Invalid refinementList in URL, resetting it.');
      }

      if (!refinementList[group]) {
        refinementList[group] = [];
      }

      const index = refinementList[group].indexOf(value);

      if (index !== -1) {
        // Value exists — remove it
        refinementList[group].splice(index, 1);
        if (refinementList[group].length === 0) {
          delete refinementList[group]; // remove group if empty
        }
      } else {
        // Value doesn't exist — add it
        refinementList[group].push(value);
      }

      // Update refinementList in the URL
      params.set('refinementList', JSON.stringify(refinementList));
    }
  }

  // Generic case: toggle other query params
  else if (params.has(key) && params.get(key) === value) {
    params.delete(key); // toggle off
  } else {
    params.set(key, value); // toggle on or change
  }

  // Finalize and update URL
  url.search = params.toString();
  window.history.replaceState({}, '', url);
}

export default updateQueryParamInUrl;
